import React from 'react';
import { PodcastEntity, ResourceEntity, Enum_Favorite_Type, CourseEntity } from '@/graphql/generated/graphql';
import LessonCard from '@/components/Learn/Lesson';
import FavoriteButton from '@/components/Favorite/FavoriteButton';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
interface CardsProps {
  entities: PodcastEntity[] | ResourceEntity[] | CourseEntity[];
  type: Enum_Favorite_Type;
}

const Cards: React.FC<CardsProps> = ({ entities, type }) => {
  return (
    <div className="flex flex-col gap-sh-30">
      {entities.length > 0 &&
        entities.map((entity) => {
          let url = `/knowledge-hub/slug/${entity?.attributes?.slug}`;
          let description = '';
          let thumbnail;

          if (entity?.__typename === 'ResourceEntity' && type === Enum_Favorite_Type.Resource) {
            description = entity.attributes?.briefDescription || '';
            thumbnail = entity.attributes?.cover;
          }

          if (entity?.__typename === 'PodcastEntity' && type === Enum_Favorite_Type.Podcast) {
            url = `/podcast/${entity.attributes?.slug}`;
            description = entity.attributes?.briefDescription || '';
            thumbnail = entity.attributes?.cover;
          }

          if (entity?.__typename === 'CourseEntity' && type === Enum_Favorite_Type.Learn) {
            url = `/learn/course/${entity.attributes?.slug}`;
            description = entity.attributes?.description || '';
            thumbnail = entity.attributes?.thumbnail;
          }

          return (
            <AnimatedFadeInComponent key={entity.id}>
              <LessonCard
                descriptionClasses="!line-clamp-6"
                key={entity.id}
                title={entity.attributes?.title || ''}
                description={description}
                thumbnail={thumbnail}
                button={<></>}
                url={url}
                favorite={<FavoriteButton relationId={entity?.id || ''} metadata={entity} type={type} />}
              />
            </AnimatedFadeInComponent>
          );
        })}
    </div>
  );
};

export default Cards;
